export enum ImageFormat {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large"
}
